import { UNIT, UNIT_HISTORY } from '../../lib/api-routes'
import { createGetByIdAction } from './createGetByIdAction'

export const getUnit = createGetByIdAction(UNIT)

export const getUnitHistory = createGetByIdAction(UNIT_HISTORY)
